import React from 'react';
import { H6 } from '../index';

const styles = {
  ulStyle: {
    display: 'inline-table',
    listStyle: 'none',
    width: '100%',
    padding: 0,
    marginTop: 0,
  },
};

const List = (fileObject: any) => (
  <ul style={styles.ulStyle}>
    <H6>Hochgeladene Dokumente</H6>
    <hr />
    {fileObject.files}
  </ul>
);

export default List;
